import { render } from "./JobseekerProfilePage.vue?vue&type=template&id=5457bc4e&scoped=true"
import script from "./JobseekerProfilePage.vue?vue&type=script&lang=js"
export * from "./JobseekerProfilePage.vue?vue&type=script&lang=js"

import "./JobseekerProfilePage.vue?vue&type=style&index=0&id=5457bc4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5457bc4e"]])

export default __exports__